import { ReactElement } from "react";

// export interface IResponseMessage {
//   message: string;
// }

export type FormatType = "JSON" | "XML" | "CSV" | "PDF";
export type ValueAccessor = (item: any) => string | number | null;
export type DefaultModule = "production" | "reports" | "meltShop" | "interruptions" | "alarms" | "general" | "mill" | "dashboardRT" | "config" | "qa";

export interface IWindowDimension {
  factor: number;
  width: number;
  height: number;
}

export const NullValue = "{NULL}";

export enum ProductionStatus {
  PENDING = 0,
  PROCESSED = 1,
  REJECTED = 2,
}

export enum  Modules {
  PRODUCTION = 1,
  INTERRUPTIONS = 2,
  ALARMS = 3,
  REPORTS = 4,
  MELTSHOP = 5,
  GENERAL = 6,
  MILL = 7,
  CONFIG = 8,
  DASHBOARD_RT = 9
}


export interface IResponseMessage {
  message: string;
  status: boolean;
}

export interface IResponseData<T> {
  message: string;
  status: boolean;
  data?: T;
}

export interface IColumn {
  id: string;
  label: string | ReactElement;
  subLabel?: string | ReactElement;
  // value: (item: any) => string | ReactNode;
  minWidth: number;
  align?: "right" | "center" | "left";
  format?: (value: number) => string;
  filter?: true;
  isHeader?: true;
  accessor?: ValueAccessor;
  render?: (value: any) => string | number | ReactElement;
}

export type languageType =  "es-mx" | "pt-br" | "en-us";

export type Order = "asc" | "desc";

export type BaseType =  string | number | boolean | null;

// export interface IDictionary<T> {
//   [Key: string]: T;
// }
//
// export interface IDictionaryNumericKey<T> {
//   [Key: number]: T;
// }
export type IDictionary<T> = Record<string, T>;

export type IDictionaryNumericKey<T> = Record<string, T>;

export interface ISortable {
  sortIndex: number;
}

export enum SchemaNodeType {
  None = "NONE",
  Factory = "FACTORY",
  Area = "AREA",
  Zone = "ZONE",
  Machine="MACHINE"
}

export enum IndicatorType {
  BOTTOM = "BOTTOM",
  DASHBOARD = "DASHBOARD"
}

export interface IBasicEntity {
  id: number;
  name: string;
  color: string | null;
  parentID?: number;
}

export interface IEntityBase {
  code: string;
  name: string;
  color: string | null;
  sortIndex?: number;
}

export interface IField {
  name: string;
  value: number | string;
  unit?: string;
}

export interface IArea extends IEntityBase {
  areaID: number;
  factoryID?: number;
}

export interface IZone extends IEntityBase {
  zoneID: number;
  areaID: number;
}

export interface IMachine extends IEntityBase {
  machineID: number;
  zoneID: number;
  previousMachineID: number | null;
}

export interface IUserData {
  userID: number;
  fullName: string;
  email: string;
  role: string;
}

export interface ILocaleConfig {
  numberFormat: string;
  dateFormat: string;
  timeFormat: string;
  language:  languageType;
  useDefaultLocale: boolean;
}

export interface IDefaultNode {
  factory: number | null;
  area: number | null;
  zone: number | null;
  view: string | null;
}

export interface ITelegramBotConfig {
  enabled: boolean;
  username: string;
  phone: string;
}

export interface ICustomUserSettings {
  defaultNode?: IDefaultNode;
  devMode?: boolean;
  telegram: ITelegramBotConfig;
}

export interface IUserConfig {
  locale: ILocaleConfig;
  darkMode: boolean;
  custom: ICustomUserSettings;
}

export interface IPermission {
  nodeID: number | null;
  nodeType: SchemaNodeType | null;
  code: string;
  name: string;
}

export interface IUser extends IUserData {
  config: IUserConfig;
  permissions: IPermission[];
}

export interface IAction {
  type: string;
  payload: any;
}

export interface  IPanelVisibility {
  left: boolean;
  right: boolean;
  bottom: boolean;
}

export interface  IWindowState {
  screenOrientation: "landscape" | "portrait";
  width: number;
  height: number;
}

export interface IFilterValues {
  mode: string;
  crew: string;
  shift: string;
  selectedFrom: string;
  selectedTo: string;
}

export interface IFilterData {
  local: IFilterValues;
  remote: IFilter;
}

export interface IState {
  dataContext: IDataContext | null;
  selectedNode: ISelectedNode;
  panels: IPanelVisibility;
  darkMode: boolean;
  language: languageType;
  alerts: IAlertData[];
  window: IWindowState;
  filter: IFilterData;
  messageContext: IMessageContext | null;
}

// export interface IMenuOption {
//   title: string,
//   icon: string,
//   color: string,
//   params: any | undefined,
//   children: IMenuOption[] | undefined | null
//   view: string | undefined | null
// }

export interface IMenuIndicator {
  title: string;
  icon: string;
  color: string;
  params: any;
  value: string;
}


export interface IDataContext {
  title: string;
  module: DefaultModule | null;
  subModule: string | null;
  flag?: string | null;
  data?: any;
}

export interface IAlertData {
  hash: undefined | string;
  message: string;
  severity: SeverityType;
}

export type SeverityType = "success" | "error" | "warning" | "info";


export interface IDetailProps {
  title: string;
  children: ReactElement;
}

export interface ISampleData {
  type: "TypeA" | "TypeB" | "TypeC";
  datetime: Date;
  data: any;
}

export interface IBucketData {
  bucketNumber: number;
  beginDatetime: Date;
  endDatetime: Date;
  weight: number;
}

export interface ILadle {
  ladleNumber: number;
}

export interface IStage {
  stageNumber: number;
  beginDatetime: Date;
  endDatetime: Date;
}

export interface IHeatData {
  heatID: number;
  heatNumber: number;
  sequence: number | null;
  workOrder: string | null;
  steel: ISteel;
}

export interface IDatetimeRange {
  beginDatetime: number;
  endDatetime: number | null;
}

export interface IEquipmentLife {
  equipment: string;
  totalUsed: number;
  currentUsed: number;
  equipmentNo: string | null;
  budgetHeats: number | null;
  location: string | null;
}

export interface IConsumption {
  materialGroup: string;
  material: string;
  quantity: number;
  UOM: string;
}

export interface IStepHistory {
  step: string;
  startTime: number | null;
  endTime: number | null;
  residenceTime: number | null;
  kwh: number | null;
  nitrogen: number | null;
  argon: number | null;
}


export interface INote {
  note: string;
}

export interface IEventHistory {
  eventHistoryID: number;
  stage: string;
  comment: string | null;
  dateTime: number;
  name: string;
  variables: IField[];
}


export interface IProductionAggregate {
  productionMachineID: number;
  variable: string;
  code: string;
  color: string | null;
  group: string;
  sortIndex: number;
  axis: IAxis;
  min: number | null;
  max: number | null;
  avg: number | null;
  desStd: number | null;
}

export interface IProductionBase extends IDatetimeRange {
  productionID: number;
  productionCatalogID: number | null;
  productionMachineID: number;
  productionMachineCatalogID: number | null;
  reference: string | null;
  shiftHistory: IShiftHistory;
  crew: ICrew;
  area: IArea;
  zone: IZone;
  machine: IMachine;
  title: string;
}

export interface IProductionExtended extends IProductionBase {
  __typename?: string;
  samples: ISample[];
  delays: DelayType[];
  variables: IVariable[];
  productionAggregates: IProductionAggregate[];
}

export interface IEAFProduction extends IHeatData, IProductionExtended {
  yield: number;
  tapToTap: number;
  powerON: number;
  powerOFF: number;
  weight: number;
  kwh: number;
  kwhTon: number;
  additions: IAddition[];
  ladleHistory: ILadleHistory | null;
}

export interface ILRFProduction extends IHeatData, IProductionExtended {
  kwh: number | null;
  lastTemp: number | null;
  lastO2PPM: number | null;
  additions: IAddition[];
  ladleHistory: ILadleHistory | null;
  equipmentLife: IEquipmentLife[];
  consumptionSummary: IConsumption[];
  stepHistory: IStepHistory[];
  notes: INote[];
}

export interface ICasterProduction extends IHeatData, IProductionExtended {
  ladleHistory: ILadleHistory | null;
  equipmentLife: IEquipmentLife[];
  events: IEventHistory[];
}

export interface IStrandProduction extends IProductionExtended {
  heatData: IHeatData | null;
  heatNumber: string;
  steelCode: string;
  millHeat: string;
  totalBillets: number;
  accumulateBillets: number;
  accumulateCobbleBillets: number;
  accumulateCutUpBillets: number;
  cobbleBillets: number;
  cutUpBillets: number;
  partitions: number;
  billets: number;
  weight: number;
  eafProductionMachineID: number | null;
  lrfProductionMachineID: number | null;
  casterProductionMachineID: number | null;
}

export interface ISampleType {
  code: string;
  machine: string;
}

export interface ISample {
  sampleHistoryID: number;
  productionMachineID: number;
  sampleDatetime: number | null;
  sampleStatus: number;
  sampleType: ISampleType;
  items: ISampleItem[];
}

export interface ICategory extends IEntityBase {
  categoryID: number;
  parentID?: number;
  keyword: string | null;
}

export interface ICategoryQMOS extends IBasicEntity {
  keyword: string;
  children: ICategoryQMOS[];
}

export interface IDelayConfigQMOS {
  categories: ICategoryQMOS[];
  responsibilities: IBasicEntity[];
}

export interface IDelayRelationship {
  areaID: number;
  equipmentID: number;
  observationID: number | null;
  reasonID: number | null;
  actionCodeID: number | null;
}

export interface IDelayConfigQMOS {
  areaGroup: IBasicEntity[];
  area: IBasicEntity[];
  equipment: IBasicEntity[];
  observation: IBasicEntity[];
  reasons: IBasicEntity[];
  actionCode: IBasicEntity[];
  responsibility: IBasicEntity[];
  relationship: IDelayRelationship[];
}

export interface IDelayBase {
  __typename: string;
  delayID: number;
  beginDatetime: number;
  endDatetime: number | null;
  duration: number | null;
  comment: string;
  editedBy: string;
  editedDatetime: number | null;
  delayType: number;
  production: IProductionBase | null;
  isDownDay: boolean;
}

export interface IDelayMeltShop extends IDelayBase {
  category: ICategory;
}
export interface IDelayQMOS extends IDelayBase {
  area: IBasicEntity | null;
  areaGroup: IBasicEntity | null;
  equipment: IBasicEntity | null;
  observation: IBasicEntity | null;
  reason: IBasicEntity | null;
  responsibility: IBasicEntity | null;
  actionCode: IBasicEntity | null;
}

export type DelayType = IDelayMeltShop | IDelayQMOS;

export interface IVariable extends IField {
  productionMachineID: number;
  datetime: number;
}

export interface IProductionMachineField extends IField {
  productionMachineID: number;
  type: "string" | "int" | "float";
}

export interface IShiftHistory {
  shiftHistoryID: number;
  shiftID: number;
  name: string;
  color: string;
  factoryDay: number;
  beginDatetime: number;
  endDatetime: number;
}

export interface IShift extends IEntityBase {
  shiftID: number;
  beginTime: string;
  span: number;
}

export interface ICrew {
  crewID: number;
  code: string;
  name: string;
  color: string;
}

export interface ISteel {
  steelID: number;
  code: string;
  version: number;
  composition: IElement[];
}

export interface IElement {
  code: string;
  name: string;
  minimum: number;
  maximum: number;
  optimal: number;
}

export interface ISampleItem {
  name: string;
  value: number;
  unit?: string;
}

export interface IAddition {
  heatAdditionID: number;
  productionMachineID: number;
  beginDatetime: number | null;
  endDatetime: number | null;
  weight: number;
  source: ISource;
  additionDetail: IAdditionDetail[];
}

export interface ISource {
  sourceID: number;
  code: string;
  name: string;
  sourceType: number;
}

export interface IAdditionDetail {
  heatAdditionDetailID: number;
  heatAdditionID: number;
  material: IMaterial;
  weight: number;
  suggestedValue?: number | null;
  setPointValue?: number | null;
}

export interface IMaterial {
  materialID: number;
  code: string;
  name: string;
}

export interface ILadleHistory {
  ladleHistoryID: number;
  heatNumber: number;
  steelCode: string;
  machineName: string;
  factoryDay: number;
  beginDatetime: number;
  endDatetime: number;
  ladle: string;
  color: string;
  weight: number;
  temperature: number;
  status: number;
}

export interface ILadleStatus extends ILadleHistory {
  heats: number;
  maintenance: number | null;
  counter: number;
}

export interface IFilter {
  nodeID?: number;
  nodeType?: SchemaNodeType;
  heatNumber?: number;
  factoryDay?: string;
  fromDate?: string;
  toDate?: string;
  shift?: string;
  crew?: string;
  steel?: string;
  machine?: string;
}

export interface IFilterResultGroup {
  title: string;
  module: string;
  subModule: string;
  flag: string | null;
  items: IFilterResult[];
}

export interface IFilterResultContext {
  heatNumber: string;
  module: DefaultModule;
  subModule: string;
  productionMachineIDs: number;
  flag: string | null;
  zone: string;
}

export interface IFilterResult {
  context: IFilterResultContext[];
  title: string;
  subTitle: string;
  content: string;
}

export interface IOptionMenu extends ISortable {
  nodeID: number;
  subModuleID: number;
  module: string;
  subModule: string;
  parentID: number | null;
  title: string;
  color: string;
  flag: string | null;
}

export interface IIndicator extends ISortable {
  nodeID: number;
  indicatorID: number;
  nodeIndicatorID: number;
  nodeType: SchemaNodeType;
  module: string;
  title: string;
  type: IndicatorType;
  component: string;
}

export interface IProperty {
  name: string;
  color?: string;
  value: string;
  unit?: string;
  title?: string;
  isOk?: boolean;
  direction?: "UP" | "DOWN" | "UNDEFINED";
}

export interface IIndicatorData {
  title: string;
  properties: IProperty[];
}

export interface ISchemaNode extends ISortable, Omit<IEntityBase, "sortIndex"> {
  nodeID: number;
  timezone: string | null;
  type: SchemaNodeType;
  inactivated: boolean;
  children?: ISchemaNode[] | null;
  menu: IOptionMenu[];
  indicator: IIndicator[];
}

export interface ISelectedNode {
  nodeID: number;
  name: string;
  code: string;
  color: string | null;
  timezone: string | null;
  children?: ISchemaNode[] | null;
  type: SchemaNodeType;
  menu: IOptionMenu[];
  indicator: IIndicator[];
}

export interface IQueryController {
  onDataArrived: (data: any) => ReactElement;
}

export interface IMenuButton {
  title: string;
  icon: ReactElement;
  color: string;
  disabled?: boolean;
  children?: IMenuButton[];
  dataContext: IDataContext;
}

export interface IViewController {
  getModuleName: () => string;
  getView: (dataContext: IDataContext, props: IContentAreaProps) => ReactElement;
  getButtons: (node: ISelectedNode) => IMenuButton[];
  getButton: (subModule: string, selectedNode?: ISelectedNode | null) => IMenuButton | undefined;
  getIndicator: (dataContext: IIndicator) => ReactElement | undefined;
}


export interface IContentAreaProps {
  parentSize: {
    width: number;
    height: number;
  };
}


export interface ILanguage {
  production: string;
  delay: string;
  gantt: string;
  profile: string;
  search: string;
  inUser: string;
  idle: string;
  down: string;
  logout: string;
  email: string;
  password: string;
  rememberMe: string;
  signIn: string;
  alarms: string;
  factoryDay: string;
  shift: string;
  crew: string;
  from: string;
  to: string;
  range: string;
  filterType: string;
  filter: string;
  all: string;
  currentWeek: string;
  lastWeek: string;
  last7Days: string;
  currentMonth: string;
  lastMonth: string;
  last30Days: string;
  realTime: string;
  session: string;
  machine: string;
  update: string;
  month_1: string;
  month_2: string;
  month_3: string;
  month_4: string;
  month_5: string;
  month_6: string;
  month_7: string;
  month_8: string;
  month_9: string;
  month_10: string;
  month_11: string;
  month_12: string;
}

export interface ICategoryPath {
  ids: number[];
  text: string;
  keyword: IDictionary<string>;
}

export interface ITreeCategoryNode extends IEntityBase {
  categoryID: number;
  keyword: string | null;
  parentID: number | null;
  path: ICategoryPath;
  children: ITreeCategoryNode[];
}

export interface IStandard {
  color1: string;
  color2: string;
  color3: string;
  color4: string;
  color5: string;
}

export interface IDarkOrLight {
  background: string;
  positive: string;
  negative: string;
}

export interface IStatusColor {
  good: IColorStyle;
  warning: IColorStyle;
  error: IColorStyle;
  info: IColorStyle;
  danger: IColorStyle;
  blueGray: IColorStyle;
  gray: IColorStyle;
  deepOrange: IColorStyle;
  cyan: IColorStyle;
  pink: IColorStyle;
  purple: IColorStyle;
  selected: IColorStyle;
  empty: IColorStyle;
  production: IColorStyle;
  delay: IColorStyle;
  scheduleDay: IColorStyle;
}

export interface ICharts {
  red: string;
  pink: string;
  purple: string;
  deepPurple: string;
  indigo: string;
  blue: string;
  lightBlue: string;
  cyan: string;
  teal: string;
  green: string;
  lightGreen: string;
  lime: string;
  yellow: string;
  amber: string;
  orange: string;
  deepOrange: string;
  gray: string;
}

export interface IPalette {
  standard: IStandard;
  dark: IDarkOrLight;
  light: IDarkOrLight;
  statusColor: IStatusColor;
  charts: ICharts;
  list: string[];
  rgbColor: string[];
}

export interface IColorStyle {
  background: string;
  color: string;
}

export interface IParentSize {
  width: number;
  height: number;
}

export interface IContentAreaProps {
  parentSize: IParentSize;
}

export interface IConsolidateData {
  minimum: number;
  maximum: number;
  average: number;
  count: number;
}

export interface IConsolidateIndicators {
  currentMonth: IConsolidateData;
  lastMonth: IConsolidateData;
  last7Days: IConsolidateData;
  currentDay: IConsolidateData;
}


export interface IVariableGroup {
  datetime: number;
  variables: IVariable[];
}

export interface IComplexData {
  module: string;
  subModule: string;
  type: string;
  content: string;
}

export interface IProduction {
  productionID: number;
  reference: string | null;
  beginDatetime: number;
  endDatetime: number | null;
  fields: IField[];
  productionMachines: IProductionExtended[];
}

export interface IProductVariable extends IField {
  productionDetailID: number;
  datetime: number;
}

export interface IXYPoint {
  x: number;
  y: number;
}

export interface ILimit {
  title: string;
  color: string;
  value: number;
}

export interface IAxis {
  axisID: number;
  name: string;
  minimum: number | null;
  maximum: number | null;
  unit: string | null;
}

export interface IProductSeries {
  name: string;
  color: string | null;
  axis: IAxis;
  limits: ILimit[];
  dataType: number;
  data: IXYPoint[];
  beginAcquisition: number;
  endAcquisition: number;
}

export interface IProductionStage {
  name: string;
  machine: string;
  beginAcquisition: number;
  endAcquisition: number;
  series: IProductSeries[];
}

export interface ISessionStatistics {
  fullName: string;
  email: string;
  totalSessions: number;
  totalQueries: number;
  idle: number;
  lastSessionBeginAt: number;
  lastSessionQueryAt: number;
}

export interface IMessageContext {
  title: string;
  color: "info" | "warning" | "danger";
  message: string;
  callback: () => void;
}

export interface ITestVariable {
  testGroup: string;
  element: string;
  value: number | null;
  minTestValue: number | null;
  intMinValue: number | null;
  aim: number | null;
  intMaxValue: number | null;
  maxTestValue: number | null;
  textValue: string;
  isOk: boolean;
  isValid: boolean | null;
  isCert: boolean | null;
  isActive: boolean | null;
  certificationMethod: any;
  employeeName: string | null;
  testDatetime: number | null;
}

export interface IMechanicalTests {
  reference: string;
  sections: Record<string, ITestVariable[]>;
}

export interface IEditionResponse {
  result: boolean;
  message: string;
  editedID: number;
}

export interface IEditionResponseWithContent<T> {
  result: boolean;
  message: string;
  editedID: number;
  content?: T;
}


export interface IAcquisitionVariable {
  code: string;
  name: string;
  color: string | null;
  axisName: string;
  axisMinimum: number | null;
  axisMaximum: number | null;
  axisUnit: string | null;
}

export interface IAcquisitionVariableFullData extends IAcquisitionVariable {
  zone: IZone;
  machine: IMachine;
}

export interface IRealtimeData {
  AcquisitionTimeStamp: number;
  Error: number;
  Value: number | string | boolean;
  Type?: string;
}


export interface ITokenData {
  token: string | null;
  userInfo: IUser | null;
  expiresAt: number | null;
}

export interface ISchemaNodePath {
  factoryID: number;
  factoryCode: string;
  areaID: number;
  areaCode: string;
  zoneID: number;
  zoneCode: string;
  machineID: number;
  machineCode: string;
}

export interface IAdditionsReportData {
  productionMachineID: number;
  beginDatetime: number;
  endDatetime: number;
  factoryDay: string;
  shiftBeginDatetime: number;
  shiftEndDatetime: number;
  shiftName: string;
  crewName: string;
  crewColor: string;
  weekNumber: number;
  monthNumber: number;
  heatNumber: number;
  steelCode: string;
  materialName: string;
  weight: number;
  suggestedValue: number;
}

export interface IAggregate {
  add: (value: number) => void;
  min: () => number;
  max: () => number;
  sum: () => number;
  count: () => number;
  avg: () => number;
  stdDev: () => number;
}

export interface IDownload {
  filename: string;
  base64: string;
}

export interface INotificationTopic {
  topicID: number;
  code: string;
  name: string;
  areaName: string;
}

export interface INotificationSubscription {
  topicID: number;
  app: boolean;
  bot: boolean;
  email: boolean;
}

export interface ISystemContextData {
  schema: ISchemaNode[];
  languageCode: "es-mx" | "pt-br" | "en-us";
  user: IUser | null;
  language: ILanguage;
  setLanguage: (languageCode: "es-mx" | "pt-br" | "en-us") => void;
  shifts: IShift[];
  crews: ICrew[];
  updateUserConfig: (config: IUserConfig) => void;
  showMessage: (messageContext: IMessageContext) => void;
}